import { render, staticRenderFns } from "./MyProductsTab.vue?vue&type=template&id=32125415&scoped=true"
import script from "./MyProductsTab.vue?vue&type=script&lang=js"
export * from "./MyProductsTab.vue?vue&type=script&lang=js"
import style0 from "./MyProductsTab.vue?vue&type=style&index=0&id=32125415&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32125415",
  null
  
)

export default component.exports